import { useEffect, useRef, useState } from "react";
import { btnSecondary } from "./ui";

/**
 * Play / pause / stop for an announcement preview (the owner's ask of
 * 2026-09-18). The audio comes as base64 from the preview route and is
 * played from a data URL.
 */
export function AudioPreview({ audio, contentType, label }: { audio: string | undefined; contentType?: string; label: string }) {
  const ref = useRef<HTMLAudioElement>(null);
  const [url, setUrl] = useState<string>();
  const [state, setState] = useState<"stopped" | "playing" | "paused">("stopped");

  useEffect(() => {
    // A data URL: a few seconds of speech is small, and nothing needs revoking.
    setUrl(audio ? `data:${contentType ?? "audio/mpeg"};base64,${audio}` : undefined);
    setState("stopped");
  }, [audio, contentType]);

  const play = () => {
    void ref.current?.play().then(() => setState("playing")).catch(() => setState("stopped"));
  };
  const pause = () => {
    ref.current?.pause();
    setState("paused");
  };
  const stop = () => {
    if (ref.current) {
      ref.current.pause();
      ref.current.currentTime = 0;
    }
    setState("stopped");
  };

  return (
    <span className="inline-flex items-center gap-1.5">
      {/* The words being spoken are on screen beside this control; a captions track would repeat them. */}
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      {url && <audio ref={ref} src={url} onEnded={() => setState("stopped")} aria-label={label} />}
      {state === "playing" ? (
        <button type="button" className={`${btnSecondary} min-h-8 px-2.5 text-xs`} onClick={pause} disabled={!url} aria-label={`Pause ${label}`}>❚❚ Pause</button>
      ) : (
        <button type="button" className={`${btnSecondary} min-h-8 px-2.5 text-xs`} onClick={play} disabled={!url} aria-label={`Play ${label}`}>▶ {state === "paused" ? "Resume" : "Play"}</button>
      )}
      <button type="button" className={`${btnSecondary} min-h-8 px-2.5 text-xs`} onClick={stop} disabled={!url || state === "stopped"} aria-label={`Stop ${label}`}>■ Stop</button>
    </span>
  );
}
